
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inquiry",
      function () {
        return require("private-next-pages/inquiry/index.tsx");
      }
    ]);
  